(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-products-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initCollectionBannerSection(section) {
    var pills = section.querySelectorAll('[data-category-pill]');
    var productContents = section.querySelectorAll('[data-products-content]');
    var bannerImages = section.querySelectorAll('.banner-col img.lazyloadt4s');
    
    if (!pills.length || !productContents.length) return;
    
    function switchPill(pillId) {
      // Update pill active states
      pills.forEach(function(pill) {
        var isActive = pill.getAttribute('data-pill-id') === pillId;
        pill.classList.toggle('t4s-active', isActive);
      });
      
      // Update product visibility
      productContents.forEach(function(content) {
        var isActive = content.getAttribute('data-pill-id') === pillId;
        content.classList.toggle('t4s-active', isActive);
      });
      
      // Update banner images
      var activePill = section.querySelector('[data-category-pill][data-pill-id="' + pillId + '"]');
      if (activePill) {
        var bannerImageDesktop = activePill.getAttribute('data-banner-image');
        var bannerImageMobile = activePill.getAttribute('data-banner-image-mb');
        
        if (bannerImageDesktop || bannerImageMobile) {
          // Find all banner images (mobile and desktop) - more specific selectors
          var mobileImg = section.querySelector('.banner-col img.t4s-d-md-none');
          var desktopImg = section.querySelector('.banner-col img.t4s-d-none.t4s-d-md-block');
          
          // Update mobile image if available
          if (bannerImageMobile && mobileImg) {
            // Start fade out - wait a bit for smooth transition
            mobileImg.classList.add('banner-image-changing');
            mobileImg.classList.remove('banner-image-loaded', 'banner-image-loading');
            
            // Wait for fade out before changing image
            setTimeout(function() {
              // Remove old attributes but keep data-widths and data-sizes for lazySizes
              var dataWidths = mobileImg.getAttribute('data-widths');
              var dataSizes = mobileImg.getAttribute('data-sizes');
              var dataOptimumx = mobileImg.getAttribute('data-optimumx');
              
              mobileImg.removeAttribute('src');
              mobileImg.removeAttribute('srcset');
              mobileImg.removeAttribute('data-srcset');
              
              // Set new data-src (use the mobile image URL)
              mobileImg.setAttribute('data-src', bannerImageMobile);
              
              // Restore lazySizes attributes
              if (dataWidths) mobileImg.setAttribute('data-widths', dataWidths);
              if (dataSizes) mobileImg.setAttribute('data-sizes', dataSizes);
              if (dataOptimumx) mobileImg.setAttribute('data-optimumx', dataOptimumx);
              
              // Update loader background (the span next to the image)
              var loaderMobile = mobileImg.nextElementSibling;
              if (loaderMobile && loaderMobile.classList.contains('lazyloadt4s-loader')) {
                loaderMobile.style.background = 'url(' + bannerImageMobile + ')';
              }
              
              // Reset lazy load state to force reload
              mobileImg.classList.remove('lazyloadt4sed', 'ls-is-cached', 'lazyautosizes');
              mobileImg.classList.add('lazyloadt4s', 'banner-image-loading');
              
              // Function to handle image load completion
              var handleMobileImageLoad = function() {
                // Small delay to ensure image is rendered
                requestAnimationFrame(function() {
                  mobileImg.classList.remove('banner-image-changing', 'banner-image-loading');
                  mobileImg.classList.add('banner-image-loaded');
                });
              };
              
              // Force immediate load if lazySizes is available
              if (window.lazySizes && window.lazySizes.loader) {
                // Listen for lazySizes loaded event
                var handleLazyLoad = function() {
                  handleMobileImageLoad();
                  mobileImg.removeEventListener('lazyloaded', handleLazyLoad);
                };
                mobileImg.addEventListener('lazyloaded', handleLazyLoad, { once: true });
                mobileImg.addEventListener('error', function() {
                  mobileImg.classList.remove('banner-image-changing', 'banner-image-loading');
                  mobileImg.classList.add('banner-image-loaded');
                }, { once: true });
                window.lazySizes.loader.unveil(mobileImg);
              } else {
                // Fallback: set src directly and listen for load
                mobileImg.addEventListener('load', handleMobileImageLoad, { once: true });
                mobileImg.addEventListener('error', function() {
                  mobileImg.classList.remove('banner-image-changing', 'banner-image-loading');
                  mobileImg.classList.add('banner-image-loaded');
                }, { once: true });
                mobileImg.src = bannerImageMobile;
              }
            }, 300); // Wait for fade out to complete
          }
          
          // Update desktop image if available
          if (bannerImageDesktop && desktopImg) {
            // Start fade out - wait a bit for smooth transition
            desktopImg.classList.add('banner-image-changing');
            desktopImg.classList.remove('banner-image-loaded', 'banner-image-loading');
            
            // Wait for fade out before changing image
            setTimeout(function() {
              // Remove old attributes but keep data-widths and data-sizes for lazySizes
              var dataWidths = desktopImg.getAttribute('data-widths');
              var dataSizes = desktopImg.getAttribute('data-sizes');
              var dataOptimumx = desktopImg.getAttribute('data-optimumx');
              
              desktopImg.removeAttribute('src');
              desktopImg.removeAttribute('srcset');
              desktopImg.removeAttribute('data-srcset');
              
              // Set new data-src (use the desktop image URL)
              desktopImg.setAttribute('data-src', bannerImageDesktop);
              
              // Restore lazySizes attributes
              if (dataWidths) desktopImg.setAttribute('data-widths', dataWidths);
              if (dataSizes) desktopImg.setAttribute('data-sizes', dataSizes);
              if (dataOptimumx) desktopImg.setAttribute('data-optimumx', dataOptimumx);
              
              // Update loader background (the span next to the image)
              var loaderDesktop = desktopImg.nextElementSibling;
              if (loaderDesktop && loaderDesktop.classList.contains('lazyloadt4s-loader')) {
                loaderDesktop.style.background = 'url(' + bannerImageDesktop + ')';
              }
              
              // Reset lazy load state to force reload
              desktopImg.classList.remove('lazyloadt4sed', 'ls-is-cached', 'lazyautosizes');
              desktopImg.classList.add('lazyloadt4s', 'banner-image-loading');
              
              // Function to handle image load completion
              var handleDesktopImageLoad = function() {
                // Small delay to ensure image is rendered
                requestAnimationFrame(function() {
                  desktopImg.classList.remove('banner-image-changing', 'banner-image-loading');
                  desktopImg.classList.add('banner-image-loaded');
                });
              };
              
              // Force immediate load if lazySizes is available
              if (window.lazySizes && window.lazySizes.loader) {
                // Listen for lazySizes loaded event
                var handleLazyLoad = function() {
                  handleDesktopImageLoad();
                  desktopImg.removeEventListener('lazyloaded', handleLazyLoad);
                };
                desktopImg.addEventListener('lazyloaded', handleLazyLoad, { once: true });
                desktopImg.addEventListener('error', function() {
                  desktopImg.classList.remove('banner-image-changing', 'banner-image-loading');
                  desktopImg.classList.add('banner-image-loaded');
                }, { once: true });
                window.lazySizes.loader.unveil(desktopImg);
              } else {
                // Fallback: set src directly and listen for load
                desktopImg.addEventListener('load', handleDesktopImageLoad, { once: true });
                desktopImg.addEventListener('error', function() {
                  desktopImg.classList.remove('banner-image-changing', 'banner-image-loading');
                  desktopImg.classList.add('banner-image-loaded');
                }, { once: true });
                desktopImg.src = bannerImageDesktop;
              }
            }, 300); // Wait for fade out to complete
          }
          
          // Additional trigger for lazySizes to check elements
          if (window.lazySizes) {
            setTimeout(function() {
              if (window.lazySizes.autoSizer) {
                window.lazySizes.autoSizer.checkElems();
              }
            }, 50);
          }
        }
      }
      
      // Reinitialize carousel if needed
      var activeContent = section.querySelector('[data-products-content].t4s-active');
      if (activeContent) {
        var carousel = activeContent.querySelector('.flickityt4s');
        if (carousel) {
          if (carousel.flickityt4s && typeof carousel.flickityt4s.resize === 'function') {
            try {
              setTimeout(function() {
                carousel.flickityt4s.resize();
              }, 100);
            } catch (e) {}
          } else if (window.t4sFlickityt4s && typeof window.t4sFlickityt4s.init === 'function') {
            window.t4sFlickityt4s.init(carousel);
          }
        }
      }
    }
    
    // Attach pill click handlers
    pills.forEach(function(pill) {
      pill.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var pillId = pill.getAttribute('data-pill-id');
        if (!pillId) return;
        
        switchPill(pillId);
      });
    });
    
    // Mark initial images as loaded (they're already visible)
    var initialMobileImg = section.querySelector('.banner-col img.t4s-d-md-none');
    var initialDesktopImg = section.querySelector('.banner-col img.t4s-d-none.t4s-d-md-block');
    if (initialMobileImg && initialMobileImg.complete) {
      initialMobileImg.classList.add('banner-image-loaded');
    }
    if (initialDesktopImg && initialDesktopImg.complete) {
      initialDesktopImg.classList.add('banner-image-loaded');
    }
    
    // Initialize: ensure active pill content is visible
    var initialPill = section.querySelector('[data-category-pill].t4s-active');
    if (initialPill) {
      var initialPillId = initialPill.getAttribute('data-pill-id');
      if (initialPillId) {
        switchPill(initialPillId);
      }
    } else if (pills.length > 0) {
      // If no active pill, activate the first one
      var firstPill = pills[0];
      var firstPillId = firstPill.getAttribute('data-pill-id');
      if (firstPillId) {
        switchPill(firstPillId);
      }
    }
  }

  function initAllCollectionBannerSections() {
    // Find all section-inner elements that contain pills
    var allSections = document.querySelectorAll('.t4s-section-inner');
    allSections.forEach(function(section) {
      // Check if this section has pills
      if (section.querySelectorAll('[data-category-pill]').length > 0) {
        initCollectionBannerSection(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCollectionBannerSections);
  } else {
    initAllCollectionBannerSections();
  }

  // Re-init in theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var sectionInner = event.target.querySelector('.t4s-section-inner');
      if (sectionInner && sectionInner.querySelectorAll('[data-category-pill]').length > 0) {
        initCollectionBannerSection(sectionInner);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zaytoon-featured-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /**
   * Start autoplay for a carousel instance
   */
  function startAutoplay(carousel) {
    try {
      var cfgStr = carousel.getAttribute('data-flickityt4s-js');
      if (!cfgStr) return;
      
      var cfg = JSON.parse(cfgStr);
      if (!cfg.autoPlay || cfg.autoPlay === false || cfg.autoPlay === 0) {
        return;
      }
      
      var flkty = carousel.flickityt4s;
      if (!flkty) return;
      
      // Try multiple methods to start autoplay
      if (flkty.player) {
        if (!flkty.player.isPlaying) {
          if (typeof flkty.playPlayer === 'function') {
            flkty.playPlayer();
          } else if (typeof flkty.player.play === 'function') {
            flkty.player.play();
          } else if (typeof flkty.player.start === 'function') {
            flkty.player.start();
          }
        }
      } else {
        // Player doesn't exist, try to create/start it
        if (typeof flkty.playPlayer === 'function') {
          flkty.playPlayer();
        } else if (typeof flkty.startPlayer === 'function') {
          flkty.startPlayer();
        } else if (typeof flkty.unpausePlayer === 'function') {
          flkty.unpausePlayer();
        }
      }
    } catch (e) {
      // Ignore errors
    }
  }

  /**
   * Ensure the Flickity instance for the visible container is healthy:
   * - make sure it is initialised
   * - trigger resize so widths are correct
   * - restart autoplay if enabled
   */
  function ensureCarouselReady(container) {
    var carousel = container.querySelector('.flickityt4s');
    if (!carousel) return;

    // Ensure container is visible before initializing
    if (!container.classList.contains('t4s-active')) {
      return;
    }

    var attempts = 0;
    var maxAttempts = 30;

    function initIfNeeded() {
      attempts += 1;

      // If Flickity instance already exists, just resize + resume autoplay
      if (carousel.flickityt4s) {
        try {
          // Fix measurements after showing a hidden container
          if (typeof carousel.flickityt4s.resize === 'function') {
            carousel.flickityt4s.resize();
          }

          // Start autoplay if enabled
          startAutoplay(carousel);
        } catch (e) {
          // fail silently – never break storefront JS
        }
        return;
      }

      // If no instance yet, wait for theme to initialize or initialize ourselves
      if (window.t4sFlickityt4s && typeof window.t4sFlickityt4s.init === 'function') {
        try {
          window.t4sFlickityt4s.init(carousel);
          
          // After initialization, wait a bit then start autoplay
          // Use multiple timeouts to ensure it works on mobile
          setTimeout(function() {
            try {
              if (carousel.flickityt4s) {
                startAutoplay(carousel);
              }
            } catch (e) {
              // Ignore errors
            }
          }, 300);
          
          // Additional retry for mobile devices
          setTimeout(function() {
            try {
              if (carousel.flickityt4s) {
                startAutoplay(carousel);
              }
            } catch (e) {
              // Ignore errors
            }
          }, 800);
        } catch (e) {
          // fail silently
        }
      } else if (window.flickityt4s && attempts < maxAttempts) {
        // Theme script not ready yet, try again
        setTimeout(initIfNeeded, 100);
      }
    }

    // Call after a delay to ensure container is visible and layout is ready
    setTimeout(initIfNeeded, 100);
    setTimeout(initIfNeeded, 300);
    setTimeout(initIfNeeded, 500);
  }

  function initZaytoonSection(section) {
    var pills = section.querySelectorAll('[data-category-pill]');
    var contents = section.querySelectorAll('[data-products-content]');

    if (!pills.length || !contents.length) return;

    function showBlock(blockId) {
      contents.forEach(function (container) {
        var isMatch = container.getAttribute('data-block-id') === blockId;
        container.classList.toggle('t4s-active', isMatch);
      });

      // After switching, ensure Flickity is healthy only for the active container
      var activeContainer = section.querySelector('.t4s-products-content.t4s-active');
      if (activeContainer) {
        setTimeout(function () {
          ensureCarouselReady(activeContainer);
        }, 150);
      }
    }

    // Attach pill click handlers
    pills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var blockId = pill.getAttribute('data-block-id');
        if (!blockId) return;

        pills.forEach(function (p) {
          p.classList.toggle('t4s-active', p === pill);
        });

        showBlock(blockId);
      });
    });

    // On initial load, ensure the default active pill + content are consistent
    var initialPill =
      section.querySelector('[data-category-pill].t4s-active') || pills[0];
    if (initialPill) {
      var initialId = initialPill.getAttribute('data-block-id');
      if (initialId) {
        showBlock(initialId);
        var initialContainer = section.querySelector('.t4s-products-content.t4s-active');
        if (initialContainer) {
          setTimeout(function () {
            ensureCarouselReady(initialContainer);
          }, 200);
        }
      }
    }
  }

  function initActiveCarousels(section) {
    var activeContainers = section.querySelectorAll('.t4s-products-content.t4s-active');
    activeContainers.forEach(function(container) {
      ensureCarouselReady(container);
      
      // Additional checks to ensure autoplay starts on mobile
      // Multiple timeouts to catch different initialization stages
      setTimeout(function() {
        var carousel = container.querySelector('.flickityt4s');
        if (carousel && carousel.flickityt4s) {
          startAutoplay(carousel);
        }
      }, 600);
      
      setTimeout(function() {
        var carousel = container.querySelector('.flickityt4s');
        if (carousel && carousel.flickityt4s) {
          startAutoplay(carousel);
        }
      }, 1200);
      
      // On mobile, also try to start autoplay after user interaction
      // Some browsers require user interaction before autoplay
      if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
        var carousel = container.querySelector('.flickityt4s');
        if (carousel) {
          var startOnInteraction = function() {
            if (carousel.flickityt4s) {
              startAutoplay(carousel);
            }
            // Remove listeners after first interaction
            document.removeEventListener('touchstart', startOnInteraction);
            document.removeEventListener('click', startOnInteraction);
          };
          
          document.addEventListener('touchstart', startOnInteraction, { once: true, passive: true });
          document.addEventListener('click', startOnInteraction, { once: true, passive: true });
        }
      }
    });
  }

  function initAllSections() {
    document
      .querySelectorAll('.t4s-advanced-collections-wrapper')
      .forEach(function (section) {
        initZaytoonSection(section);
        initActiveCarousels(section);
      });
  }

  // Wait for DOM and ensure Flickity scripts are loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      // Small delay to ensure theme's Flickity scripts are loaded
      setTimeout(initAllSections, 50);
    });
  } else {
    setTimeout(initAllSections, 50);
  }

  // Re-init inside Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var wrapper = event.target.querySelector('.t4s-advanced-collections-wrapper');
      if (wrapper) {
        initZaytoonSection(wrapper);
        initActiveCarousels(wrapper);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
